import apk from "./contrall-2.33(119)-release.apk";

export default apk;
